import PublicIcon from "@mui/icons-material/Public";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";
import { Link } from "react-router-dom";
import Highlight from "components/ui/atoms/Highlight";
import GoogleDriveIcon from "components/ui/icons/googleDrive.svg";
import CompanyWatcher from "../company_watchers/CompanyWatcher";
import SlackLink from "components/ui/atoms/SlackLink";
import FormHeader from "components/ui/atoms/FormHeader";

const CreateFormHeader = ({}) => {
  const theme = useTheme();

  return (
    <Highlight color={theme.palette_custom.yellow}>Create company</Highlight>
  );
};

const UpdateFormHeader = ({ company }) => {
  const theme = useTheme();

  return (
    <>
      <Stack sx={{ ml: 1 }}>
        <Highlight color={theme.palette_custom.yellow}>
          <Link to={`/company/${company.id}/`}>{company.best_name}</Link>
        </Highlight>
        <Typography variant="caption">
          {`Created at ${new Date(
            Date.parse(company.created_at),
          ).toLocaleDateString()}`}
        </Typography>
      </Stack>
      <Box
        sx={{
          display: "flex",
          flexWrap: "nowrap",
          alignItems: "center",
          ml: "auto",
        }}
      >
        <CompanyWatcher companyId={company.id} />
        <SlackLink slack_channel_id={company.slack_channel_id} />
        <a href={company.website} target="_blank">
          <IconButton>
            <PublicIcon />
          </IconButton>
        </a>
        {company.link_drive && (
          <a href={`${company.link_drive}`} target="_blank">
            <IconButton>
              <Box>
                <img src={GoogleDriveIcon} />
              </Box>
            </IconButton>
          </a>
        )}
      </Box>
    </>
  );
};

const CompanyFormHeader = ({ formType, onClose, ...props }) => {
  let header;
  if (formType == "create") header = <CreateFormHeader {...props} />;
  if (formType == "update") header = <UpdateFormHeader {...props} />;

  return <FormHeader onClose={onClose}>{header}</FormHeader>;
};

export default CompanyFormHeader;
